import Vue from 'vue';

export default class OrganisationConfigurationActions {
  constructor(resource, organisationCode, customConfig) {
    this.resource = resource;
    this.organisationCode = organisationCode;
    this.customConfig = customConfig;
  }

  getPublic() {
    return Vue.prototype.$axiosMainClient.get(
      `organisations/${this.organisationCode}/${this.resource}/public`,
      this.customConfig
    );
  }

  getLogo() {
    return Vue.prototype.$axiosMainClient.get(`organisations/${this.organisationCode}/${this.resource}/logo`,
    this.customConfig);
  }
}
